import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import { colors } from 'utils/colors';
import { isQuoteMedia } from 'utils/helpers';

import TradeTable from './TradeTable';
import { translation as translationTools } from '../../Translation/tools';

class ReallocatePDF extends Component {
  constructor(props) {
    super(props);
    const mql = window.matchMedia('print');

    this.state = {
      isPrintReady: false,
      mql,
    };
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.state.mql.addListener(this.printListener);

    return false;
  }

  componentDidMount() {
    this.timeoutId = window.setTimeout(
      () => this.setState({ isPrintReady: true }),
      1000
    );
  }

  componentDidUpdate(prevProps, prevState) {
    this.render();
    if (this.state.isPrintReady !== prevState.isPrintReady) {
      const originalTitle = document.title;

      document.title = 'Portfolio_Reallocation';
      window.print();
      document.title = originalTitle;
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeoutId);
    this.state.mql.removeListener(this.printListener);
  }

  printListener = (e) => {
    const { history } = this.props;
    // resize charts on print
    if (e.matches) {
      Object.keys(window.Chart.instances).forEach((key) => {
        window.Chart.instances[key].resize();
      });
    } else {
      history.goBack();
    }
  };

  render() {
    const { french, partnerName } = this.props;
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    return (
      <PDF>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Header as="h2" style={{ color: colors.darkBlue, marginTop: '10px' }}>
            {translationTools[language][translateEnding].RESULTS_TITLE}
          </Header>
          <p style={{ color: '#6D6E71', textAlign: 'center' }}>
            {translationTools[language][translateEnding].RESULTS_SUBTITLE}
          </p>
        </div>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <TradeTable />
        </div>
      </PDF>
    );
  }
}

ReallocatePDF.propTypes = {
  history: PropTypes.object,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};

ReallocatePDF.defaultProps = {
  history: {},
  french: false,
  partnerName: '',
};

export default connect((state) => ({
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))(ReallocatePDF);

const PDF = styled.div`
  position: relative;
  background: white;
  text-align: center;
  padding: 2.5rem;
  border-radius: 8px;
  width: 1160px;
  margin: -55px auto 5px auto;

  @media only print {
    print-color-adjust: exact;

    @page {
      size: auto;
      margin: 0.5cm;
    }
  }
`;
